import { TrendingOutlineIcon } from '@carboncopyco/icons';
import { Badge, TextTooltip } from '@carboncopyco/ui';
import { isDesktop } from '@carboncopyco/utils';
import type { MouseEventHandler } from 'react';
import { SidebarButton } from './SidebarButton';

export interface DashboardButtonProps {
  isSelected: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const DesktopTooltipTitle = () => (
  <div className="flex items-center gap-1 pt-1.5 pb-0.5 px-0.5">
    <TextTooltip
      label="Analytics"
      color="text-ds-natural-50"
    />
    <Badge
      size="sm"
      variant="primary"
      label="web"
    />
  </div>
);

export const DashboardButton = ({
  isSelected,
  onClick,
}: DashboardButtonProps) => (
  <SidebarButton
    isSelected={isSelected}
    onClick={onClick}
    aria-label="Dashboard Button"
    tooltipText={isDesktop() ? <DesktopTooltipTitle /> : 'Analytics'}
  >
    <TrendingOutlineIcon size={20} />
  </SidebarButton>
);
